export default "__VITE_ASSET__CbUGwh92__"